/** 이슈 면(사각형·폴리곤) 채움의 알파 — 2D `ANNOTATION_COLOR.*.fill` 과 3D 사각형 미리보기·생성 결과가 같은 값을 읽는다 */
export const ANNOTATION_FILL_ALPHA = 0.3;
